import { Divider, Stack } from '@mui/material';
import React from 'react';
import { NavLink } from 'react-router-dom';
import { usePageNavigationMenu } from 'pages/AppManagement/hooks/UsePageNavigationMenu';
import { isEmpty } from 'lodash';
import styles from '../containers/container.module.scss';
const TopBarNavigationMenu: React.FC = () => {
  const topBarNavigation = usePageNavigationMenu();

  return !isEmpty(topBarNavigation) ? (
    <>
      <Stack direction="row">
        {topBarNavigation.map(menu => (
          <NavLink
            key={menu.name}
            className={styles.topBarLink}
            isActive={
              menu.queryParam
                ? (match, location) => {
                    if (!match) return false;
                    const queryParams = new URLSearchParams(location.search);
                    return queryParams.get(menu.queryParam as string) === menu.value;
                  }
                : undefined
            }
            exact
            to={menu.href}
            activeClassName={styles.topMenuActive}
          >
            {menu.name}
          </NavLink>
        ))}
      </Stack>
      <Divider orientation="vertical" flexItem sx={{ backgroundColor: '#FFF', opacity: '0.1', height: '36px' }} />
    </>
  ) : null;
};

export default TopBarNavigationMenu;
